<template>
    <v-card outlined>
      <v-card-text>
        <div class="d-flex align-center mb-4">
          <div class="text-h6">Historial de Requisiciones</div>
          <v-spacer></v-spacer>
<!--           <v-btn
            color="primary"
            small
            @click="generarRequi"
            :loading="guardando"
          >
            <v-icon left small>mdi-plus</v-icon>
            Generar requisición
          </v-btn> -->
        </div>

        <!-- Tabla de historial de requisiciones -->
        <v-data-table
          :headers="requisicionHeaders"
          :items="historialRequisiciones"
          :items-per-page="5"
          class="elevation-1"
          :loading="loadingRequisiciones"
          loading-text="Cargando... Por favor, espere"
          no-data-text="No hay registros disponibles"
        >
          <template v-slot:item.fecha_registro="{ item }">
            {{ item.fecha_registro_formatted }}
          </template>

          <template v-slot:item.estatus="{ item }">
            <v-chip
              small
              :color="item.estatus_color"
              text-color="white"
            >
              {{ item.estatus_texto }}
            </v-chip>
          </template>

          <template v-slot:item.monto="{ item }">
            {{ formatCurrency(item.monto) }}
          </template>

          <template v-slot:item.evidencia="{ item }">
            <v-icon
              v-if="item.tiene_evidencia"
              color="primary"
              small
              @click="mostrarEvidencia(item)"
            >
              mdi-image
            </v-icon>
            <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              x-small
              icon
              color="primary"
              @click="subirEvidencia(item)"
              :disabled="item.tiene_evidencia"
              class="mr-1"
            >
              <v-icon small>mdi-upload</v-icon>
            </v-btn>
            <v-btn
              x-small
              icon
              color="error"
              @click="confirmarEliminarRequisicion(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- Modal para subir evidencia -->
      <v-dialog v-model="dialogSubirEvidencia" max-width="500px">
        <v-card>
          <v-card-title class="headline">
            Subir Evidencia
          </v-card-title>
          <v-card-text>
            <v-file-input
              v-model="evidenciaFile"
              label="Seleccionar imagen"
              accept="image/*"
              prepend-icon="mdi-camera"
              :rules="[v => !!v || 'La imagen es requerida']"
              show-size
              counter
            ></v-file-input>
            <v-img
              v-if="previewImage"
              :src="previewImage"
              max-height="200"
              contain
              class="mt-3"
            ></v-img>
            <div v-if="ocr_procesando" class="mt-3 text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <div class="mt-2">Procesando imagen y extrayendo datos...</div>
            </div>

            <v-alert
              v-if="ocr_completado && montoDetectado > 0"
              dense
              :color="diferenciaDetectada > 0.5 ? 'warning' : (diferenciaDetectada < -0.5 ? 'orange' : 'success')"
              class="mt-3"
            >
              <div class="font-weight-bold">Datos extraídos:</div>
              <div>Monto detectado: {{ formatCurrency(montoDetectado) }}</div>
              <div v-if="Math.abs(diferenciaDetectada) > 0.5">
                <strong>
                  Diferencia: {{ diferenciaDetectada > 0 ? '-' : '+' }}{{ formatCurrency(Math.abs(diferenciaDetectada)) }}
                </strong>
              </div>
              <div v-if="referenciaServicio">Referencia/Servicio: {{ referenciaServicio }}</div>
              <div v-if="fechaOperacion">Fecha: {{ fechaOperacion }}</div>
              <div v-if="folioOperacion">Folio: {{ folioOperacion }}</div>
              <div v-if="cuentaEscuela">Cuenta: {{ cuentaEscuela }}</div>
              <div v-if="bancoDetectado">Banco: {{ bancoDetectado }}</div>
              <div v-if="tipoPagoDetectado">Tipo: {{ tipoPagoDetectado }}</div>
            </v-alert>
            <v-alert
              v-if="ocr_completado && montoDetectado <= 0"
              dense
              color="info"
              class="mt-3"
            >
              No se pudo extraer automáticamente el monto del comprobante.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="cerrarDialogSubirEvidencia"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="guardarEvidencia"
              :loading="guardandoEvidencia"
              :disabled="!evidenciaFile"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal para mostrar evidencia -->
      <v-dialog v-model="dialogMostrarEvidencia" max-width="700px">
        <v-card>
          <v-card-title class="headline">
            Evidencia de Requisición {{ requisicionSeleccionadaEvidencia ? requisicionSeleccionadaEvidencia.folio : '' }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <!-- Lado izquierdo: Imagen -->
              <v-col cols="12" md="7" class="text-center">
                <v-img
                  v-if="imagenEvidenciaUrl"
                  :src="imagenEvidenciaUrl"
                  max-height="500"
                  contain
                ></v-img>
                <div v-else class="pa-4 text-center">
                  No se pudo cargar la imagen
                </div>
              </v-col>

              <!-- Lado derecho: Datos extraídos -->
              <v-col cols="12" md="5">
                <v-card outlined class="mb-3" v-if="requisicionSeleccionadaEvidencia && requisicionSeleccionadaEvidencia.monto_detectado">
                  <v-card-title class="subtitle-1">
                    Datos extraídos por OCR
                  </v-card-title>
                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-icon><v-icon small>mdi-cash</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Monto detectado</v-list-item-title>
                          <v-list-item-subtitle>{{ formatCurrency(requisicionSeleccionadaEvidencia.monto_detectado) }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="requisicionSeleccionadaEvidencia.diferencia_detectada && Math.abs(requisicionSeleccionadaEvidencia.diferencia_detectada) > 0.5">
                        <v-list-item-icon>
                          <v-icon small :color="requisicionSeleccionadaEvidencia.diferencia_detectada > 0 ? 'warning' : 'orange'">
                            {{ requisicionSeleccionadaEvidencia.diferencia_detectada > 0 ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ requisicionSeleccionadaEvidencia.diferencia_detectada > 0 ? 'Faltante' : 'Sobrante' }}
                          </v-list-item-title>
                          <v-list-item-subtitle :class="requisicionSeleccionadaEvidencia.diferencia_detectada > 0 ? 'red--text' : 'green--text'">
                            {{ formatCurrency(Math.abs(requisicionSeleccionadaEvidencia.diferencia_detectada)) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="requisicionSeleccionadaEvidencia.referencia_servicio">
                        <v-list-item-icon><v-icon small>mdi-tag</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Referencia</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia.referencia_servicio }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="requisicionSeleccionadaEvidencia.fecha_operacion">
                        <v-list-item-icon><v-icon small>mdi-calendar</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Fecha de operación</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia.fecha_operacion }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="requisicionSeleccionadaEvidencia.folioOperacion">
                        <v-list-item-icon><v-icon small>mdi-file-document-outline</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Folio</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia.folioOperacion }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="requisicionSeleccionadaEvidencia.tipoPagoDetectado">
                        <v-list-item-icon><v-icon small>mdi-credit-card-outline</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Método de pago</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia.tipoPagoDetectado }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="requisicionSeleccionadaEvidencia.bancoDetectado">
                        <v-list-item-icon><v-icon small>mdi-bank</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Banco</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia.bancoDetectado }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>

                <v-alert v-else type="info" dense>
                  No hay datos OCR disponibles para esta evidencia
                </v-alert>

                <!-- Información de la requisición -->
                <v-card outlined>
                  <v-card-title class="subtitle-1">
                    Datos de la requisición
                  </v-card-title>
                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-icon><v-icon small>mdi-cash-multiple</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Monto solicitado</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia ? formatCurrency(requisicionSeleccionadaEvidencia.monto) : '-' }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-icon><v-icon small>mdi-calendar-check</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Fecha de registro</v-list-item-title>
                          <v-list-item-subtitle>{{ requisicionSeleccionadaEvidencia ? requisicionSeleccionadaEvidencia.fecha_registro_formatted : '-' }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-icon><v-icon small>mdi-information-outline</v-icon></v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Estado</v-list-item-title>
                          <v-list-item-subtitle>
                            <v-chip x-small :color="requisicionSeleccionadaEvidencia ? requisicionSeleccionadaEvidencia.estatus_color : 'grey'" text-color="white">
                              {{ requisicionSeleccionadaEvidencia ? requisicionSeleccionadaEvidencia.estatus_texto : '-' }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogMostrarEvidencia = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal para confirmar eliminación de requisición -->
      <v-dialog v-model="dialogConfirmacion" max-width="400px">
        <v-card>
          <v-card-title class="headline">
            Confirmar Eliminación
          </v-card-title>
          <v-card-text>
            ¿Está seguro que desea eliminar esta requisición?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="dialogConfirmacion = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="error"
              @click="eliminarRequisicion"
              :loading="eliminando"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </template>

  <script>
  import { mapGetters } from 'vuex'

  import leerImagenes from '@/mixins/leerImagenes'

  export default {
    name: 'GenerarRequisiciones',
    mixins: [leerImagenes],
    props: {
      servicio: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      loadingRequisiciones: false,
      guardando: false,
      requisicionSeleccionada: null,
      dialogConfirmacion: false,
      requisicionAEliminar: null,
      eliminando: false,
      historialRequisiciones: [],

      dialogSubirEvidencia: false,
      dialogMostrarEvidencia: false,
      requisicionSeleccionadaEvidencia: null,
      evidenciaFile: null,
      previewImage: null,
      imagenEvidenciaUrl: null,
      guardandoEvidencia: false,

      montoDetectado: 0,
      diferenciaDetectada: 0,
      ocr_completado: false,
      ocr_procesando: false,
      folioOperacion: null,
      cuentaEscuela: null,
      bancoDetectado: '',
      tipoPagoDetectado: '',

      referenciaServicio: null,
      fechaOperacion: null,

      loadingOCRData: false,

      requisicionHeaders: [
        { text: 'Folio', value: 'id', align: 'center' },
        { text: 'Detalle', value: 'comentarios' },
        { text: 'Monto', value: 'monto' },
        { text: 'Fecha', value: 'fecha_registro' },
        { text: 'Estado', value: 'estatus' },
        { text: 'Evidencia', value: 'evidencia', align: 'center' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ]
    }),

    computed: {
      ...mapGetters('login', ['getCCNNUsuario'])
    },

    methods: {
      formatFecha(fecha) {
        return new Date(fecha).toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      },

      async cargarHistorialRequisiciones() {
        this.loadingRequisiciones = true;
        try {
          // Usar el ID correcto del servicio
          const idServicio = this.servicio.id_servicio_sistema || this.servicio.idservicios_sistemas;

          if (!idServicio) {
            console.error("Error: ID de servicio no disponible");
            return;
          }

          // Obtener las requisiciones
          const response = await this.$http.get(`requisiciones.list.by_servicio/${idServicio}`);

          // Mapear los datos
          const requisiciones = response.data.map( req => ({
            id: req.id || req.idrequisicion_compra,
            folio: `REQ-${(req.id || req.idrequisicion_compra).toString().padStart(4, '0')}`,
            fecha_registro: req.fecha_registro || req.fecha_alta,
            fecha_registro_formatted: this.formatFecha(req.fecha_registro || req.fecha_alta),
            comentarios: req.comentarios || '',
            monto: req.monto_solicitado || 0, // Usamos monto_solicitado de servicios_sistemas
            estatus: req.estatus || req.id_requisicion_compra_estatus,
            estatus_texto: this.getEstatusTexto(req.estatus || req.id_requisicion_compra_estatus),
            estatus_color: this.getEstatusColor(req.estatus || req.id_requisicion_compra_estatus),
            tiene_evidencia: !!req.evidencia_url || !!req.evidencia,
            evidencia_url: req.evidencia ? `${window.location.protocol}//${window.location.host}/comprobantes-egresos/evidencias/${req.evidencia}` : null,

            monto_detectado: req.monto_detectado || null,
            diferencia_detectada: req.diferencia_detectada || null,
            referencia_servicio: req.referencia_servicio || null,
            fecha_operacion: req.fecha_operacion || null,
            folioOperacion: req.folio_operacion || null,
            bancoDetectado: req.banco || null,
            tipoPagoDetectado: req.tipo_pago || null,
            cuentaEscuela: req.cuenta || null
          }));


          // Ordenar por fecha más reciente primero
          requisiciones.sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));

          // Actualizar la lista
          this.historialRequisiciones = requisiciones;
        } catch (error) {
          console.error('Error al cargar historial de requisiciones:', error);
          this.$emit('mostrar-error', 'Error al cargar el historial de requisiciones');
        } finally {
          this.loadingRequisiciones = false;
        }
      },

      formatCurrency(value) {
        return new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN'
        }).format(value);
      },

      async generarRequi() {
        this.guardando = true;

        try {
          // Obtener el ID correcto del servicio
          const idServicio = this.servicio.id_servicio_sistema || this.servicio.idservicios_sistemas;

          // Payload con los campos necesarios
          const payload = {
            registro: null,
            id_usuario_solicita: this.getCCNNUsuario.iderp,
            id_sucursal_solicita: this.getCCNNUsuario.id_plantel || this.servicio.id_plantel,
            id_requisicion_compra_estatus: 1,
            id_usuario_ultimo_cambio: this.getCCNNUsuario.iderp,
            id_usuario_compra: 28,
            tipo_requisicion: this.servicio.id_tipo_elemento || 1,
            id_ciclo: this.servicio.ciclo,
            id_proyecto: null,
            idproveedores: this.servicio.proveedor || null,
            idservicios_sistemas: idServicio,
            comentarios: `Pago de Servicio: ${this.servicio.egreso_programado || this.servicio.servicio}`,
            monto: this.servicio.monto_solicitado || 0, // Aseguramos incluir el monto en el payload
            id_elemento_requisicion: 1,
            detalles: [
              {
                id_elemento_requisicion: this.servicio.id_tipo_elemento,
                id_plantel: this.getCCNNUsuario.id_plantel,
                concepto:  `Pago de Servicio: ${this.servicio.egreso_programado || this.servicio.servicio}`,
                cantidad: 1,
                costo_unitario: pago.monto_solicitado,
                costo_total: pago.monto_solicitado,
                id_usuario_ultimo_cambio: this.getCCNNUsuario.iderp,
                id_empleado: this.getCCNNUsuario.iderp,
                id_alumno: null,
                id_grupo: null,
                id_plantel_resultados: this.getCCNNUsuario.id_plantel || this.servicio.id_plantel,
                idhistorial_nomina: null
              }
            ],
            fotos: []
          };

          // Enviar requisición
          const response = await this.$http.post('generar.requi.detalles', payload);

          // Extraer el ID de la requisición generada
          const idRequisicion = response.data.idrequisicion_compra;

          if (!idRequisicion) {
            throw new Error("No se pudo generar la requisición correctamente");
          }

          // Agregar la nueva requisición al historial local
          const nuevaRequisicion = {
            id: idRequisicion,
            folio: `REQ-${idRequisicion.toString().padStart(4, '0')}`,
            fecha_registro: new Date().toISOString(),
            fecha_registro_formatted: this.formatFecha(new Date()),
            comentarios: payload.comentarios,
            monto: this.servicio.monto_solicitado || 0, // Aseguramos usar el monto del servicio
            estatus: 1, // estado inicial
            estatus_texto: this.getEstatusTexto(1),
            estatus_color: this.getEstatusColor(1)
          };

          // Agregar al inicio de la lista para que aparezca primero
          this.historialRequisiciones.unshift(nuevaRequisicion);

          // Mostrar mensaje de éxito
          this.$emit('mostrar-exito', `Requisición generada correctamente. ID: ${idRequisicion}`);

          // También refrescar la lista completa desde el servidor
          await this.cargarHistorialRequisiciones();

        } catch (error) {
          console.error('Error al generar requisición:', error);

          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al generar la requisición';

          this.$emit('mostrar-error', errorMessage);
        } finally {
          this.guardando = false;
        }
      },

      async generarRequiDesdePrograma(pago) {
        // console.log('GenerarRequisiciones: Iniciando generación de requisición desde pago:', pago);

        this.guardando = true;

        try {
          // Obtener el ID correcto del servicio
          const idServicio = this.servicio.id_servicio_sistema || this.servicio.idservicios_sistemas;
          // console.log('GenerarRequisiciones: ID del servicio:', idServicio);

          // Payload con los campos necesarios, usando datos del pago programado
          const payload = {
            registro: null,
            id_usuario_solicita: this.getCCNNUsuario.iderp,
            id_sucursal_solicita: this.getCCNNUsuario.id_plantel || this.servicio.id_plantel,
            id_requisicion_compra_estatus: 1,
            id_usuario_ultimo_cambio: this.getCCNNUsuario.iderp,
            id_usuario_compra: 28,
            tipo_requisicion: this.servicio.id_tipo_elemento || 1,
            id_ciclo: pago.ciclo || 345,
            id_proyecto: null,
            idproveedores: pago.proveedor || this.servicio.proveedor || null,
            idservicios_sistemas: idServicio,
            comentarios: `Pago de Servicio: ${this.servicio.egreso_programado || this.servicio.servicio}`,
            monto: pago.monto_solicitado || 0,
            id_elemento_requisicion: 1,
            detalles: [
            {
                id_elemento_requisicion: this.servicio.id_tipo_elemento,
                id_plantel: this.getCCNNUsuario.id_plantel,
                concepto:  `Pago de Servicio: ${this.servicio.egreso_programado || this.servicio.servicio}`,
                cantidad: 1,
                costo_unitario: pago.monto_solicitado,
                costo_total: pago.monto_solicitado,
                id_usuario_ultimo_cambio: this.getCCNNUsuario.iderp,
                id_empleado: this.getCCNNUsuario.iderp,
                id_alumno: null,
                id_grupo: null,
                id_plantel_resultados: this.getCCNNUsuario.id_plantel || this.servicio.id_plantel,
                idhistorial_nomina: null
              }
            ],
            fotos: []
          };
          // console.log('GenerarRequisiciones: Payload a enviar:', payload);

          // Enviar requisición
          const response = await this.$http.post('generar.requi.detalles', payload);

          // Extraer el ID de la requisición generada
          const idRequisicion = response.data.idrequisicion_compra;

          if (!idRequisicion) {
            throw new Error("No se pudo generar la requisición correctamente");
          }

          // Agregar la nueva requisición al historial local
          const nuevaRequisicion = {
            id: idRequisicion,
            folio: `REQ-${idRequisicion.toString().padStart(4, '0')}`,
            fecha_registro: new Date().toISOString(),
            fecha_registro_formatted: this.formatFecha(new Date()),
            comentarios: payload.comentarios,
            monto: pago.monto_solicitado || 0,
            estatus: 0, // estado inicial
            estatus_texto: this.getEstatusTexto(1),
            estatus_color: this.getEstatusColor(1)
          };

          // Agregar al inicio de la lista para que aparezca primero
          this.historialRequisiciones.unshift(nuevaRequisicion);

          // Mostrar mensaje de éxito
          this.$emit('mostrar-exito', `Requisición generada correctamente desde pago programado. ID: ${idRequisicion}`);

          // También refrescar la lista completa desde el servidor
          await this.cargarHistorialRequisiciones();

        } catch (error) {
          console.error('Error al generar requisición desde pago programado:', error);

          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al generar la requisición desde pago programado';

          this.$emit('mostrar-error', errorMessage);
        } finally {
          this.guardando = false;
        }
      },

      // Método para abrir el diálogo de confirmación
      confirmarEliminarRequisicion(item) {
        this.requisicionAEliminar = item;
        this.dialogConfirmacion = true;
      },

      // Método para eliminar la requisición
      async eliminarRequisicion() {
        this.eliminando = true;
        try {
          // Llamar a la API para eliminar la requisición
          await this.$http.delete(`requisiciones.delete/${this.requisicionAEliminar.id}`);

          // Eliminar la requisición de la lista local
          const index = this.historialRequisiciones.findIndex(r => r.id === this.requisicionAEliminar.id);
          if (index !== -1) {
            this.historialRequisiciones.splice(index, 1);
          }

          // Mostrar mensaje de éxito
          this.$emit('mostrar-exito', 'Requisición eliminada correctamente');

          // Cerrar el diálogo de confirmación
          this.dialogConfirmacion = false;
          this.requisicionAEliminar = null;
        } catch (error) {
          console.error('Error al eliminar requisición:', error);

          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al eliminar la requisición';

          this.$emit('mostrar-error', errorMessage);
        } finally {
          this.eliminando = false;
        }
      },

      subirEvidencia(item) {
        this.requisicionSeleccionadaEvidencia = item;
        this.evidenciaFile = null;
        this.previewImage = null;
        this.dialogSubirEvidencia = true;
      },

      // Método para cerrar el diálogo de subir evidencia
      cerrarDialogSubirEvidencia() {
        this.dialogSubirEvidencia = false;
        this.requisicionSeleccionadaEvidencia = null;
        this.evidenciaFile = null;
        this.previewImage = null;
        this.ocr_completado = false;
        this.montoDetectado = 0;
        this.referenciaServicio = null;
        this.fechaOperacion = null;
      },

      // Método para mostrar la vista previa de la imagen
      async handleFileChange() {
        if (this.evidenciaFile) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;

            // Preparar los datos para el OCR
            this.file = this.evidenciaFile;
            this.archivos = this.evidenciaFile;

            // Procesar la imagen con OCR
            this.ocr_procesando = true;
            this.total_pagado = 0; // Reiniciamos el valor

            // Llamar al método del mixin para extraer datos
            this.getBase64(this.archivos);
            this.procesarImagen2();

            // Configurar un temporizador para verificar cuando el OCR haya terminado
            const checkOCR = setInterval(() => {
              if (this.total_pagado > 0 || !this.ocr_procesando) {
                clearInterval(checkOCR);
                this.ocr_completado = true;
                this.compararMontos();
              }
            }, 500);

            // Establecer un tiempo máximo de espera (15 segundos)
            setTimeout(() => {
              clearInterval(checkOCR);
              this.ocr_procesando = false;
              if (!this.ocr_completado) {
                // No se pudo completar el OCR
                console.log("No se pudo extraer el monto automáticamente");
              }
            }, 15000);
          };
          reader.readAsDataURL(this.evidenciaFile);
        } else {
          this.previewImage = null;
          this.ocr_completado = false;
          this.montoDetectado = 0;
        }
      },

      async guardarEvidencia() {
        if (!this.evidenciaFile) return;

        this.guardandoEvidencia = true;

        try {
          // Crear un objeto FormData para enviar la imagen
          const formData = new FormData();
          formData.append('imagen', this.evidenciaFile);
          formData.append('id', this.requisicionSeleccionadaEvidencia.id);
          formData.append('id_usuario_ultimo_cambio', this.getCCNNUsuario.iderp);
          // formData.append('id_requisicion_compra_estatus', 8)

          // Añadir datos detectados por OCR
          if (this.ocr_completado && this.montoDetectado > 0) {
            formData.append('monto_detectado', this.montoDetectado);
            formData.append('diferencia_detectada', this.diferenciaDetectada);
            formData.append('referencia_servicio', this.referenciaServicio || '');
            formData.append('fecha_operacion', this.fechaOperacion || '');
            formData.append('folio_operacion', this.folioOperacion);
            formData.append('cuenta', this.cuentaEscuela);
            formData.append('banco', this.bancoDetectado);
            formData.append('tipo_pago', this.tipoPagoDetectado);
          }


          // Enviar la imagen al servidor
          const response = await this.$http.post('requisiciones.update.evidencia', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          console.log('Respuesta al guardar evidencia:', response.data);

          // Actualizar el estado de la requisición en el frontend
          const index = this.historialRequisiciones.findIndex(r => r.id === this.requisicionSeleccionadaEvidencia.id);
          if (index !== -1) {
            this.historialRequisiciones[index].tiene_evidencia = true;
            this.historialRequisiciones[index].evidencia_url = response.data.evidencia_url;

            // Actualizar los datos del OCR si están disponibles
            if (this.ocr_completado) {
              this.historialRequisiciones[index].monto_detectado = this.montoDetectado;
              this.historialRequisiciones[index].diferencia_detectada = this.diferenciaDetectada;
              this.historialRequisiciones[index].referencia_servicio = this.referenciaServicio;
              this.historialRequisiciones[index].fecha_operacion = this.fechaOperacion;
            }
          }

          // Mostrar mensaje de éxito
          let mensaje = 'Evidencia guardada correctamente';
          if (this.ocr_completado && this.montoDetectado > 0) {
            mensaje += `. Monto detectado: ${this.formatCurrency(this.montoDetectado)}`;

            if (Math.abs(this.diferenciaDetectada) > 0.5) {
              if (this.diferenciaDetectada > 0) {
                mensaje += `. ¡Atención! Hay una diferencia de ${this.formatCurrency(this.diferenciaDetectada)} (faltante)`;
              } else {
                mensaje += `. Hay un sobrante de ${this.formatCurrency(Math.abs(this.diferenciaDetectada))}`;
              }
            }
          }

          this.$emit('mostrar-exito', mensaje);

          // Cerrar el diálogo
          this.dialogSubirEvidencia = false;
          this.requisicionSeleccionadaEvidencia = null;
          this.evidenciaFile = null;
          this.previewImage = null;
          this.ocr_completado = false;
          this.montoDetectado = 0;
          this.diferenciaDetectada = 0;
          this.referenciaServicio = null;
          this.fechaOperacion = null;
        } catch (error) {
          console.error('Error al guardar evidencia:', error);

          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al guardar la evidencia';

          this.$emit('mostrar-error', errorMessage);
        } finally {
          this.guardandoEvidencia = false;
          this.ocr_procesando = false;
        }
      },

      // Método para mostrar la evidencia
      async mostrarEvidencia(item) {
        console.log('Mostrando evidencia para:', item.id, 'Tiene evidencia:', item.tiene_evidencia, 'URL:', item.evidencia_url);
        this.requisicionSeleccionadaEvidencia = item;
        this.imagenEvidenciaUrl = item.evidencia_url;

        // Si tiene evidencia pero no datos OCR, intentamos cargarlos
        if (item.tiene_evidencia && (!item.monto_detectado && !item.referencia_servicio)) {
          try {
            // Mostrar un indicador de carga si quieres
            this.loadingOCRData = true;

            const response = await this.$http.get(`requisiciones.get.ocr_data/${item.id}`);

            if (response.data) {
              // Actualizar el item local con datos OCR
              item.monto_detectado = response.data.monto_detectado || null;
              item.diferencia_detectada = response.data.diferencia_detectada || null;
              item.referencia_servicio = response.data.referencia_servicio || null;
              item.fecha_operacion = response.data.fecha_operacion || null;
              item.folioOperacion = response.data.folio_operacion || null;
              item.bancoDetectado = response.data.banco || null;
              item.tipoPagoDetectado = response.data.tipo_pago || null;
              item.cuentaEscuela = response.data.cuenta || null;

              // Actualizar en la lista local también
              const index = this.historialRequisiciones.findIndex(r => r.id === item.id);
              if (index !== -1) {
                this.historialRequisiciones[index] = { ...this.historialRequisiciones[index], ...item };
              }
            }
          } catch (error) {
            console.error('Error al cargar datos OCR adicionales:', error);
          } finally {
            this.loadingOCRData = false;
          }
        }

        this.dialogMostrarEvidencia = true;
      },

      compararMontos() {
        if (this.total_pagado > 0 && this.requisicionSeleccionadaEvidencia) {
          this.montoDetectado = this.total_pagado;
          this.diferenciaDetectada = this.requisicionSeleccionadaEvidencia.monto - this.montoDetectado;

          // Guardar otros datos extraídos
          this.folioOperacion = this.folio_operacion || '';
          this.cuentaEscuela = this.cuenta || '';
          this.bancoDetectado = this.banco || '';

          // Determinar el tipo de pago
          if (this.isPracticaja) this.tipoPagoDetectado = 'Practicaja';
          else if (this.isTransferencia) this.tipoPagoDetectado = 'Transferencia';
          else if (this.isSeven) this.tipoPagoDetectado = 'Seven';
          else if (this.isOXXO) this.tipoPagoDetectado = 'OXXO';
          else if (this.isWeb) this.tipoPagoDetectado = 'Web';
          else if (this.isTarjeta) this.tipoPagoDetectado = 'Tarjeta';
          else this.tipoPagoDetectado = 'Desconocido';
        }
      },

      procesarDatosAdicionales() {
        // Verificar que tengamos el texto completo del OCR
        if (!this.texto_completo) return;

        const lineasTexto = this.texto_completo.split('\n');

        // Para recibos de Banregio, buscar específicamente estas etiquetas
        for (let i = 0; i < lineasTexto.length; i++) {
          // Buscar la línea que contiene "Referencia"
          if (lineasTexto[i].includes('Referencia')) {
            // En este formato, la referencia suele estar en la misma línea, a la derecha
            // O en la línea siguiente si el OCR la separó

            // Intentar extraer de la misma línea primero
            let partes = lineasTexto[i].split(/\s+/);
            if (partes.length > 1) {
              // Si hay algo después de "Referencia" en la misma línea
              // Tomar la última parte (el número)
              this.referenciaServicio = partes[partes.length - 1];

              // Verificar si lo que obtuvimos parece un número de referencia
              // (los números de referencia de CFE suelen ser largos)
              if (this.referenciaServicio && this.referenciaServicio.length < 10) {
                // Si es demasiado corto, probablemente no es la referencia completa
                // Intentar con la línea siguiente
                if (i + 1 < lineasTexto.length) {
                  this.referenciaServicio = lineasTexto[i + 1].trim();
                }
              }
            } else if (i + 1 < lineasTexto.length) {
              // Si "Referencia" está sola en su línea, tomar la línea siguiente
              this.referenciaServicio = lineasTexto[i + 1].trim();
            }

            // Limpiar el resultado de posibles caracteres no deseados
            if (this.referenciaServicio) {
              // Eliminar espacios y caracteres especiales comunes
              this.referenciaServicio = this.referenciaServicio.replace(/[^\d]/g, '');
            }
          }

          // Buscar la fecha de autorización
          if (lineasTexto[i].includes('Fecha de autorización')) {
            // Intentar extraer de la misma línea primero
            const fechaEnLinea = lineasTexto[i].replace('Fecha de autorización', '').trim();

            if (fechaEnLinea && fechaEnLinea.length > 3) {
              this.fechaOperacion = fechaEnLinea;
            } else if (i + 1 < lineasTexto.length) {
              // Si no hay fecha en la misma línea, tomar la línea siguiente
              this.fechaOperacion = lineasTexto[i + 1].trim();
            }

          }
        }

        // Si no se encontró la referencia con el método anterior, intentar otro enfoque
        if (!this.referenciaServicio) {
          // Buscar patrones específicos de referencias de CFE en todo el texto
          // (números largos que podrían ser la referencia)
          const referenciaRegex = /\d{20,}/g; // Buscar secuencias de 20 o más dígitos
          const posiblesReferencias = this.texto_completo.match(referenciaRegex);

          if (posiblesReferencias && posiblesReferencias.length > 0) {
            // Tomar la primera coincidencia larga (probablemente la referencia)
            this.referenciaServicio = posiblesReferencias[0];
          }
        }
      },

      getEstatusTexto(estatus) {
        const estatusMap = {
          1: 'Nueva',             
          2: 'Pendiente',         
          3: 'Autorizada',        
          4: 'Rechazada',         
          5: 'Pre Autorizada',    
          6: 'Aceptada',          
          7: 'Procesada',         
          8: 'Con evidencia'      
        };
        return estatusMap[estatus] || 'Desconocido';
      },

      // Obtiene el color del estado
      getEstatusColor(estatus) {
        const colorMap = {
          1: 'grey',              
          2: 'blue',              
          3: 'green',             
          4: 'black',             
          5: 'orange',            
          6: 'green',             
          7: 'green',             
          8: 'info'             
        };
        return colorMap[estatus] || 'grey';
      }
    },

    mounted() {
      this.cargarHistorialRequisiciones();
    },
    watch: {
      evidenciaFile() {
        this.handleFileChange();
      },
      ocr_completado(newVal) {
        if (newVal === true) {
          this.procesarDatosAdicionales();
        }
      },
      // También podemos observar el texto_completo
      'texto_completo'(newVal) {
        if (newVal) {
          this.procesarDatosAdicionales();
        }
      }
    },
  }
  </script>
